export default __webpack_public_path__ + "static/media/Screenshot crypto3.3b441004.png";